import React, { useState, useEffect } from "react";
import { useCart } from "../context/CartContext";
import { useUser } from "../context/UserContext";

const Basket = ({ onCheckoutClick, isMobileCheckout }) => {
  const { cartItems, updateCartItemQuantity, removeItemFromCart } =
    useCart();
  const { user, openLoginModal } = useUser();
  const [isMobileBasketOpen, setIsMobileBasketOpen] = useState(false);

  useEffect(() => {
    if (isMobileBasketOpen) {
      document.body.style.overflow = "hidden"; // lock scroll
    } else {
      document.body.style.overflow = "auto"; // unlock scroll
    }

    return () => {
      document.body.style.overflow = "auto"; // cleanup
    };
  }, [isMobileBasketOpen]);

  const cartCount = cartItems.reduce((acc, item) => acc + item.quantity, 0);

  const getItemTotals = (item) => {
    let total = parseFloat(item.price || 0);
    const options = [];

    if (item.selectedRequiredOption) {
      total += parseFloat(item.selectedRequiredOption.option_price || 0);
      options.push({
        name: item.selectedRequiredOption.option_name,
        price: item.selectedRequiredOption.option_price,
      });
    }

    [
      ...(item.swallowOptions || []),
      ...(item.mainProteins || []),
      ...(item.extraProteins || []),
    ].forEach((opt) => {
      const optTotal = parseFloat(opt.option_price || 0) * (opt.quantity || 1);
      total += optTotal;
      options.push({
        name: opt.option_name + (opt.quantity > 1 ? ` x${opt.quantity}` : ""),
        price: optTotal.toFixed(2),
      });
    });

    return { total, options };
  };

  const grandTotal = cartItems
    .reduce((acc, { item, quantity }) => {
      const { total } = getItemTotals(item);
      return acc + total * quantity;
    }, 0)
    .toFixed(2);

  // Open checkout only if user is logged in
  const handleCheckout = (type) => {
    if (!user) return openLoginModal(); // require login
    onCheckoutClick(type);
  };

  const renderCartItems = () =>
    cartItems.map(({ item, quantity, key }) => {
      const { total, options } = getItemTotals(item);
      const finalTotal = (total * quantity).toFixed(2);

      return (
        <li key={key} className="cart-item">
          <div className="cart-item-left">
            <div className="cart-item-header">
              <span className="cart-item-name">{item.item_name}</span>
              <span className="cart-item-price">
                £{parseFloat(item.price || 0).toFixed(2)}
              </span>
            </div>

            {options.map((opt, idx) => (
              <div key={idx} className="cart-item-option">
                <span className="option-name">{opt.name}</span>
                <span className="option-price">£{opt.price}</span>
              </div>
            ))}

            <div className="cart-item-footer">
              <span className="final-total">£{finalTotal}</span>
              <div className="cart-controls">
                <button
                  className="qty-btn"
                  onClick={() =>
                    quantity > 1
                      ? updateCartItemQuantity(key, quantity - 1)
                      : removeItemFromCart(key)
                  }
                >
                  −
                </button>
                <span>{quantity}</span>
                <button
                  className="qty-btn"
                  onClick={() => updateCartItemQuantity(key, quantity + 1)}
                >
                  +
                </button>
              </div>
            </div>
          </div>

          <div className="cart-item-right">
            <button
              className="delete-btn"
              onClick={() => removeItemFromCart(key)}
            >
              <i className="fa fa-trash"></i>
            </button>
          </div>
        </li>
      );
    });

  return (
    <>
      {/* DESKTOP BASKET */}
      {!isMobileCheckout && (
        <aside className="basket-section desktop-basket">
          <div className="basket-header">
            <h3 className="basket-title">
              <span className="cart-icon">
                <i className="fa fa-shopping-cart"></i>
                {cartItems.length > 0 && (
                  <span className="cart-count">{cartCount}</span>
                )}
              </span>
              Basket
            </h3>
            {/* {cartItems.length > 0 && (
              <button className="clear-cart-button" onClick={clearCart}>
                <i className="fa fa-trash"></i> Empty Basket
              </button>
            )} */}
          </div>

          {cartItems.length === 0 ? (
            <p className="empty-basket">Your basket is empty</p>
          ) : (
            <ul className="basket-list">{renderCartItems()}</ul>
          )}

          {cartItems.length > 0 && (
            <div className="basket-footer">
              <p className="basket-total">
                <span>Checkout</span> £{grandTotal}
              </p>
              <div className="checkout-buttons">
                <button
                  className="add-to-cart-button checkout-btn"
                  onClick={() => handleCheckout("eat-in")}
                >
                  Eat In
                </button>
                <button
                  className="add-to-cart-button checkout-btn"
                  onClick={() => handleCheckout("pickup")}
                >
                  Pick Up
                </button>
              </div>
            </div>
          )}
        </aside>
      )}

      {/* MOBILE BOTTOM BAR */}
      {isMobileCheckout && cartItems.length > 0 && (
        <>
          <div className="mobile-checkout-bar">
            <div className="mobile-checkout-bar-left">
              <span
                className="cart-icon"
                onClick={() => setIsMobileBasketOpen(!isMobileBasketOpen)}
                style={{ cursor: "pointer" }}
              >
                <i className="fa fa-shopping-cart"></i>
                <span className="cart-count">{cartCount}</span>
              </span>
            </div>

            <div className="mobile-checkout-bar-right">
              <button
                className="add-to-cart-button mobile-checkout-btn"
                onClick={() => handleCheckout(null)}
              >
                Checkout &nbsp; &nbsp; £{grandTotal}
              </button>
            </div>
          </div>

          {/* MOBILE BASKET OVERLAY */}
          {isMobileBasketOpen && (
            <div className="mobile-basket-container open">
              {/* Empty Basket Button */}
              {/* <div className="mobile-clear-cart">
                <button className="clear-cart-button" onClick={clearCart}>
                  <i className="fa fa-trash"></i> Empty Basket
                </button>
              </div> */}

              <ul className="basket-list">{renderCartItems()}</ul>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default Basket;
